    console.log('customymq1111')
    window.after_init_ymq_option = function () {
        console.log('customymq22222')
        // 设置提示内容
        const customizerTop = document.querySelectorAll('.customizer-top-content');
        const customizerBot = document.querySelectorAll('.customizer-bot-content');
        const topText =
          'Note: US Standard Sizing. Please verify measurements.<br/>Please note that the measurements on this size chart represent the dimensions of the clothing, not body measurements.<br/><span style="color: #D52A1A">Please refer to our size chart before order, the customized jerseys are special products. We don\'t accept cancel, change, return after order has been placed.</span>';

        const botText =
          'Use the chart above to determine your size. If you’re on the borderline between two sizes, order the smaller size for a tighter fit or the larger size for a looser fit. If your measurements for chest and waist correspond to two different suggested sizes, order the one indicated by your chest measurement.';
        const additionalText = `
  
          6XL: Ideal for slender individuals at high altitudes, offering a comfortable fit.<br/>
          7XL: Tailored for fuller figures, providing extra room and comfort.<br/><br/>
        `;
        // 设置 HTML 内容
        customizerTop.forEach((el) => {
          el.innerHTML = topText;
        });
        customizerBot.forEach((el) => {
          el.innerHTML = botText;
        });

        // 外层 tabs 和 panels：按模块分组处理，避免全局冲突
        document.querySelectorAll('.outer-tabs').forEach((tabGroup, groupIndex) => {
          const tabs = tabGroup.querySelectorAll('button');

          // 找到对应的 outer-panels 容器（确保顺序一致）
          const panelGroup = document.querySelectorAll('.outer-tab-panels')[groupIndex];
          if (!panelGroup) return;
          const panels = panelGroup.querySelectorAll('.tab-panel');

          tabs.forEach((tab, tabIndex) => {
            tab.addEventListener('click', () => {
              console.log(111111111111)
              // 当前组中清除 active
              tabs.forEach((btn) => btn.classList.remove('active'));
              panels.forEach((panel) => panel.classList.remove('active'));

              // 当前 tab、panel 加 active
              tab.classList.add('active');
              panels[tabIndex].classList.add('active');
            });
          });
        });

        // 内层 tab 切换（每个 outer-panel 内）
        document.querySelectorAll('.outer-tab-panels').forEach((panelGroup) => {
          panelGroup.querySelectorAll('.tab-panel').forEach((panel) => {
            const innerButtons = panel.querySelectorAll('.inner-tab-buttons button');
            const innerPanels = panel.querySelectorAll('.inner-tab-panel');

            innerButtons.forEach((btn, index) => {
              btn.addEventListener('click', () => {
                innerButtons.forEach((b) => b.classList.remove('active'));
                innerPanels.forEach((p) => p.classList.remove('active'));

                btn.classList.add('active');
                innerPanels[index].classList.add('active');
              });
            });
          });
        });
    };
